
var oLink = document.getElementsByClassName('pdp_ColorSwatch');
var doc;
for(var i = 0; i < oLink.length; i++) {
 
oLink[i].addEventListener('click',function (e) {
    console.log("Clicked index: " + i);
    var handle = e.target.getAttribute("data-handle");
    window.location.href = "/products/"+handle+"";
    fetch("/products/"+handle+"?view=copy").then(function(response) {
        return response.text();
    }).then(function(string) {
        //document.getElementsByClassName("main")[0].innerHTML = string; 
        //setInnerHTML(document.getElementsByClassName("main")[0], string);
        //window.history.pushState('Brandsie', handle, '/products/'+handle);
        //var productEle = n$2(".product",document);
        //var Product2 = new Product(productEle);
        //document.getElementsByClassName("product")[0].classList.add("is-visible");
    });
  e.stopPropagation();
},true);

  }




  function setInnerHTML(elm, html) {
    elm.innerHTML = html;
    
    Array.from(elm.querySelectorAll("script"))
      .forEach( oldScriptEl => {
        const newScriptEl = document.createElement("script");
        
        Array.from(oldScriptEl.attributes).forEach( attr => {
          newScriptEl.setAttribute(attr.name, attr.value) 
        });
        
        const scriptText = document.createTextNode(oldScriptEl.innerHTML);
        try{
            if(oldScriptEl.innerHTML.indexOf("ShopifyXR") == -1){
            newScriptEl.appendChild(scriptText);
        
            oldScriptEl.parentNode.replaceChild(newScriptEl, oldScriptEl);
            }
        }
        catch(e){}
    });
  }
  